module.exports = __webpack_public_path__ + "static/media/fish.d91b18a1.svg";